import { render } from "./bindView.vue?vue&type=template&id=566dccdc&scoped=true"
import script from "./bindView.vue?vue&type=script&lang=js"
export * from "./bindView.vue?vue&type=script&lang=js"

import "./bindView.vue?vue&type=style&index=0&id=566dccdc&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566dccdc"]])

export default __exports__